import React from 'react';

import {GlobalHeaderButtons} from "../PageLayout/GlobalHeaderButtons";
import SearchBar from "../SearchBar";

const FeaturesSetupHeader = (props) => {

  const {activeFeatureGroup, group, searchTerm, featuresSetupSetSearchTerm} = props;

  const handleInputChange = async (event) => {
    featuresSetupSetSearchTerm(event.target.value);
  }

  return (
    <div className="app-header app-header-adj">
      <GlobalHeaderButtons/>
      <div className="lightbox-header-container">
        <div className="lightbox-title-block">
          <h1 id="PageTitle">
            {activeFeatureGroup && activeFeatureGroup.customDisplayName ? activeFeatureGroup.customDisplayName : group}
          </h1>
        </div>
      </div>
      <SearchBar value={searchTerm} componentClassName="app-search--on-top" onChange={handleInputChange}/>
    </div>
  )
};

export default FeaturesSetupHeader
